export default [{
  path: 'appmanage/:leftid/:parent_id',
  redirect: to => {
    return '/kdsuper/appversion/' + to.params.leftid + '/' + to.params.parent_id
  }
}, {
  path: 'appversion/:leftid/:parent_id',
  name: 'backend_appversion',
  component: () => import('@/views/backend/admin/app/AppManagerMain'),
  meta: {
    tpflag: 'backend',
    title: '版本管理',
  }
}, {
  path: 'apppush/:leftid/:parent_id',
  name: 'backend_apppush',
  component: () => import('@/views/backend/admin/app/AppManagerMain'),
  meta: {
    tpflag: 'backend',
    title: '版本推送',
  }
}, {
  path: 'apploginlog/:leftid/:parent_id',
  name: 'backend_apploginlog',
  component: () => import('@/views/backend/admin/app/AppManagerMain'),
  meta: {
    tpflag: 'backend',
    title: '登录统计',
  }
}, {
  path: 'appdownload/:leftid/:parent_id',
  name: 'backend_appdownload',
  component: () => import('@/views/backend/admin/app/AppManagerMain'),
  meta: {
    tpflag: 'backend',
    title: '下载二维码',
  }
}]



// WEBPACK FOOTER //
// ./src/router/kdsuper/_app.js